export function logout() {
  localStorage.removeItem('access-token');
  localStorage.removeItem('access-token-mkm');
  localStorage.removeItem('refresh-token-mkm');
  localStorage.setItem('cart-items', '[]');
  location.href = '/';
}
